module.exports = __webpack_public_path__ + "overview-a5b6df21/emptystate-871f3f7f1049c60915d6879f54cb9921.svg";